export const statusPreviewTranslation = (string, t) => {
  return t(string);
};
